var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReplyToIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.928,
    height: 9
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1041",
    d: "M7.429 4.5L.501.5v8z",
    fill: "#747474",
    stroke: "#707070",
    strokeLinejoin: "round",
    opacity: 0.5
  })));
}

export default SvgReplyToIcon;